import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Select } from "antd";
import dayjs from "dayjs";

import { useProjectState } from "../../../context/stateContext";
import productProfitabilityAction from "../../../redux/productProfitability/actions";
import "./index.css";

const { Option } = Select;
const { getProductProfitabilityData } = productProfitabilityAction;

const ProductProfitabilityActions = () => {
  const {
    selectedOrganization,
    allSectedRestaurants,
    setAllSelectedRestaurants,
  } = useProjectState();
  const dispatch = useDispatch();
  const { restaurants, organizations } = useSelector(
    (state) => state.getOrganizationAndRestaurantReducer
  );

  // Винаги вчерашния ден
  const yesterday = dayjs().subtract(1, "day");

  const defaultOrganization = organizations.filter(
    (itemInArray) => itemInArray.id === selectedOrganization
  );

  const defaultTouchSaleRestaurantId =
    defaultOrganization[0]?.defaultTouchSaleRestaurantId;
  useEffect(() => {
    if (defaultOrganization.length > 0) {
      setAllSelectedRestaurants([
        defaultOrganization[0]?.defaultTouchSaleRestaurantId,
      ]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOrganization, defaultTouchSaleRestaurantId]);

  useEffect(() => {
    window.localStorage.setItem("restaurantId", allSectedRestaurants);
    const timer = setTimeout(() => {
      const formattedDate = yesterday.format("YYYY-MM-DD"); // винаги вчера
      const params = {
        date: formattedDate,
        selectedRestaurant: allSectedRestaurants,
      };
      dispatch(getProductProfitabilityData(params));
    }, 1000);

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allSectedRestaurants, selectedOrganization]);

  return (
    <div className="product-profitability-action-buttons-container">
      {defaultOrganization[0]?.multipleRestaurants && (
        <Select
          showSearch={false}
          virtual={false}
          key="productProfitabilitySelect"
          placeholder="Изберете ресторант"
          value={allSectedRestaurants[0] || undefined}
          onChange={(value) => setAllSelectedRestaurants([value])}
          className="product-profitability-action-buttons"
        >
          {restaurants?.map((restaurant, index) => (
            <Option
              key={restaurant.id}
              value={restaurant.id}
              className="product-profitability-action-select-option"
            >
              {restaurant.name}
            </Option>
          ))}
        </Select>
      )}
    </div>
  );
};

export default ProductProfitabilityActions;
